module.exports = "/fonts/vendor/@fortawesome/fontawesome-free/webfa-v4compatibility.woff2?cf7f5903d06b79ad60f1d96e3a4ab9bd";